const isModernBrowser = (): boolean => {
  // These globals are always present in the DOM lib types, but this is a runtime
  // feature-detect for older browsers that genuinely lack them, so read each through
  // an `unknown`-typed view to check actual presence without TS "always defined" errors.
  const globalWindow = window as unknown as Record<string, unknown>;
  const arrayProto = Array.prototype as unknown as Record<string, unknown>;
  const intl = Intl as Record<string, unknown> | undefined;

  return !!(
    globalWindow.Promise &&
    globalWindow.fetch &&
    globalWindow.Symbol &&
    globalWindow.ResizeObserver &&
    globalWindow.IntersectionObserver &&
    arrayProto.at &&
    intl?.ListFormat
  );
};

export { isModernBrowser };
